import IconAlert from '@apollo/icons/default/IconAlert.svg';
import IconAlertOff from '@apollo/icons/default/IconAlertOff.svg';
import { Button, Spinner } from '@apollo/orbit';
import React from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';
import Config from 'src/lib/config';
import { NotificationStatus } from 'src/lib/graphqlTypes/types';
import { setOverlayVisibleLocation } from 'src/lib/routing';

export const ProposalNotificationToggle = ({
  notificationStatus,
}: {
  notificationStatus: NotificationStatus | undefined;
}) => {
  const notificationsEnabled = notificationStatus === NotificationStatus.ALL;

  const location = useLocation();

  return (
    <Tooltip
      placement="bottom"
      label={
        <>
          {notificationsEnabled
            ? 'Disable proposal notifications'
            : 'Enable proposal notifications'}{' '}
          (You will only receive notifications for proposals you've authored or
          participated in.)
        </>
      }
      disabled={!notificationStatus}
    >
      <Button
        variant="secondary"
        className="mr-1 min-w-fit"
        as={Link}
        to={setOverlayVisibleLocation({
          location,
          overlayName: Config.modals.setProposalNotificationStatus,
        })}
        {...(notificationStatus
          ? {
              leftIcon: notificationsEnabled ? <IconAlert /> : <IconAlertOff />,
            }
          : {})}
      >
        {notificationStatus ? (
          notificationsEnabled ? (
            'On'
          ) : (
            'Off'
          )
        ) : (
          <Spinner size="tiny" />
        )}
      </Button>
    </Tooltip>
  );
};
